import PropTypes from "prop-types";

import useSection from "common/routes/sections/sections.hooks";
import HeaderComponent from "./header.component";

function Header({ className }) {
  const section = useSection();

  return <HeaderComponent section={section} className={className} />;
}

Header.propTypes = {
  className: PropTypes.string,
};

Header.defaultProps = {
  className: "",
};

export default Header;
